import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBubble4"><Path d="M18.252 3C19.7707 3 21.002 4.23122 21.002 5.75V17.25C21.002 18.7688 19.7707 20 18.252 20H8.03875C7.99189 20 7.94598 20.0132 7.90625 20.038L4.14945 22.386C3.91825 22.5305 3.62684 22.5382 3.38838 22.406C3.14991 22.2738 3.00195 22.0226 3.00195 21.75V5.75C3.00195 4.23122 4.23317 3 5.75195 3H18.252Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble4;
